/**
 * @generated SignedSource<<a104a465600c0a3831bf933bbdfd74ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRespRelatedItem_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_viewer" | "ItemTile_viewer">;
  readonly " $fragmentType": "SharedRespRelatedItem_viewer";
};
export type SharedRespRelatedItem_viewer$key = {
  readonly " $data"?: SharedRespRelatedItem_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespRelatedItem_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespRelatedItem_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5a6ca32ed40a055fc3873e8d941337ae";

export default node;
